<section class="section">
    <div class="container">
        <div class="quote-panel" style="max-width:460px;margin:0 auto">
            <span class="section-kicker">Admin Panel</span>
            <h2 style="font-size:34px;margin-top:8px">Login</h2>

            <div class="form-grid" style="grid-template-columns:1fr">
                <div class="field">
                    <label>Username</label>
                    <input name="username" [(ngModel)]="username" placeholder="">
                </div>

                <div class="field">
                    <label>Password</label>
                    <input name="password" type="password" [(ngModel)]="password" placeholder="">
                </div>

                <div class="field" *ngIf="errorMessage">
                    <div class="alert error">{{ errorMessage }}</div>
                </div>

                <div class="field">
                    <button class="btn btn-primary" type="button" (click)="login()" [disabled]="loading">
                        {{ loading ? 'Signing in...' : 'Login' }}
                    </button>
                </div>
            </div>
        </div>
    </div>
</section>